<template>
    <!-- 标记组件 -->
    <div class="vel-badge">
        <!-- 定位模式 -->
        <el-badge 
        v-if="position"
        :value="value"
        :max="max"
        :is-dot="dot"
        :type="type"
        >   
            <!-- 定位模式插槽 -->
            <slot></slot>
        </el-badge>
        <!-- inLine模式 -->
        <div 
        v-else 
        class="vel-badge-inline"
        >
            <el-badge 
            class="vel-badge-inline-dot"
            :is-dot="true"
            :type="type"
            /> 
            <!-- 行内模式插槽 -->
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name:"VelBadge",
    props:{
        value:{
            type:[Number,String],
            default:0
        },
        max:Number,
        isDot:Boolean,
        type:String,
        isInline:Boolean
    },
    data() {
        return {
            dot:false,
            position:true
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isDot ? this.dot = true : this.dot
            this.isInline ? this.position = false : this.position
        }
    },
}
</script>
<style scoped>
.vel-badge-inline{
    display: flex;
    align-items: center;
}
.vel-badge-inline-dot{
    display: flex;
    align-items: center;
    margin-right: 5px;
}
</style>